import { useInventoryContext } from "@/DataPages/components/Inventory/contexts/InventoryFilterContext";
import { useMemo } from "react";
import get from "lodash-es/get";
import { PropertyPaths } from "@/Common/helpers/typeHelpers";
import { InventoryTab, ORIGIN_TAB_MAP } from "../constants";
import { getLogger } from "@/Common/helpers/getLogger";

const log = getLogger("useFilteredData");

type IUseFilteredDataArgs<T> = {
	data: T[];
	pathToVinNumber: PropertyPaths<T, string>;
	currentOrigin: InventoryTab;
	commissionCycleId: string;
	payPeriodId: string;
};

export const useFilteredData = <T>(args: IUseFilteredDataArgs<T>) => {
	const { data, pathToVinNumber, currentOrigin, commissionCycleId, payPeriodId } = args;
	const { filterItems } = useInventoryContext();
	log("Rendering useFilteredData");

	const pathArray = useMemo(() => pathToVinNumber.split("."), [pathToVinNumber]);

	const selectedVinNumbers = useMemo(() => {
		log("Filtering selected vin numbers");
		const allowedOrigins = ORIGIN_TAB_MAP[currentOrigin];
		const filteredItems = filterItems.filter((item) => {
			const isFromAllowedOrigin = allowedOrigins.includes(item.origin);
			const isFromSameCCandPP = item.commissionCycleId === commissionCycleId && item.payPeriodId === payPeriodId;
			return !(isFromAllowedOrigin && isFromSameCCandPP);
		});
		log("Allowed origins: %O", allowedOrigins);
		log("Filtered items: %O", filteredItems);
		return filteredItems.map((item) => item.vinNumber);
	}, [filterItems, currentOrigin, commissionCycleId, payPeriodId]);

	return useMemo(() => {
		if (!selectedVinNumbers.length) {
			return data;
		}
		return data.filter((item) => selectedVinNumbers.includes(get(item, pathArray)));
	}, [data, pathToVinNumber, selectedVinNumbers]);
};
